var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 8.33268V4.99935C20.3333 4.11529 19.9821 3.26745 19.357 2.64233C18.7319 2.0172 17.8841 1.66602 17 1.66602H5.33333C4.44928 1.66602 3.60143 2.0172 2.97631 2.64233C2.35119 3.26745 2 4.11529 2 4.99935V24.9993C2 25.8834 2.35119 26.7312 2.97631 27.3564C3.60143 27.9815 4.44928 28.3327 5.33333 28.3327H17C17.8841 28.3327 18.7319 27.9815 19.357 27.3564C19.9821 26.7312 20.3333 25.8834 20.3333 24.9993V21.666",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 15H32L27 10M27 20L32 15",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.2383e22fc96dee148ae05fd2db4a6b4f.svg";
export { ForwardRef as ReactComponent };